import {mapGetters, mapActions} from 'vuex'

const adminMixin = {
  data() {
    return {
      defaultActive: '',
      defaultActives: {
        'API_MANAGE_DEVELOPER': '开发者管理',
        'API_MANAGE_STATISTICS': '整体趋势',
        'API_MANAGE_USER': '用户管理',
        'API_MANAGE_BASIC_DATA': '学段管理'
      },
    }
  },
  computed: {
    ...mapGetters(['userinfo'])
  },
  methods: {
    valid (rightCode) {
      if (this.userinfo && this.userinfo.authorities && this.userinfo.authorities) {
        let rights = []
        for (let item of this.userinfo.authorities) {
          rights.push(item.authority)
        }
        // 权限
        if (rights && rights.length > 0) {
          let _default = rights[0]
          this.defaultActive = this.defaultActives[_default]
          return rights.join(',').indexOf(rightCode) > -1
        }
      }
      return false
    },
  },
}

export default adminMixin;



// WEBPACK FOOTER //
// ./src/mixins/adminMixin.js